import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SortDirection } from '../../utils/SortUtils';
import Select from '../selects/Select';
import ToggleButton from '../button/ToggleButton';
var TableCardsSorting = /*#__PURE__*/function (_Component) {
  _inherits(TableCardsSorting, _Component);
  var _super = _createSuper(TableCardsSorting);
  function TableCardsSorting(props) {
    var _this;
    _classCallCheck(this, TableCardsSorting);
    _this = _super.call(this, props);
    _this.state = {
      sortName: _this.props.sortName,
      sortOrder: _this.props.sortOrder
    };
    _this.setSortName = _this.setSortName.bind(_assertThisInitialized(_this));
    _this.setSortDirectionAsc = _this.setSortDirectionAsc.bind(_assertThisInitialized(_this));
    _this.setSortDirectionDesc = _this.setSortDirectionDesc.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(TableCardsSorting, [{
    key: "setSortDirectionAsc",
    value: function setSortDirectionAsc() {
      this.setSortDirection(SortDirection.ASCENDING);
    }
  }, {
    key: "setSortDirectionDesc",
    value: function setSortDirectionDesc() {
      this.setSortDirection(SortDirection.DESCENDING);
    }
  }, {
    key: "setSortDirection",
    value: function setSortDirection(direction) {
      this.setState({
        sortOrder: direction
      });
      this.props.onSortChange(this.state.sortName, direction);
    }
  }, {
    key: "setSortName",
    value: function setSortName(item) {
      this.setState({
        sortName: item.id
      });
      this.props.onSortChange(item.id, this.state.sortOrder);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        selectOptions = _this$props.selectOptions;
      var sortOrder = this.state.sortOrder;
      var wrapperClassNames = classNames('table-toolbar-cards-sorting', 'btn-toolbar', className && className);
      return /*#__PURE__*/React.createElement("div", {
        className: wrapperClassNames
      }, /*#__PURE__*/React.createElement("div", {
        className: "btn-group margin-left-0"
      }, /*#__PURE__*/React.createElement(ToggleButton, {
        className: 'btn-icon-only',
        active: sortOrder === SortDirection.ASCENDING,
        onClick: this.setSortDirectionAsc
      }, /*#__PURE__*/React.createElement("span", {
        className: "rioglyph rioglyph-sort-by-attributes-alt"
      })), /*#__PURE__*/React.createElement(ToggleButton, {
        className: 'btn-icon-only',
        active: sortOrder === SortDirection.DESCENDING,
        onClick: this.setSortDirectionDesc
      }, /*#__PURE__*/React.createElement("span", {
        className: "rioglyph rioglyph-sort-by-attributes"
      }))), selectOptions.length && /*#__PURE__*/React.createElement("div", {
        className: "btn-group"
      }, /*#__PURE__*/React.createElement(Select, {
        options: selectOptions,
        onChange: this.setSortName
      })));
    }
  }]);
  return TableCardsSorting;
}(Component);
TableCardsSorting.defaultProps = {
  onSortChange: function onSortChange() {},
  sortOrder: SortDirection.ASCENDING,
  selectOptions: []
};
TableCardsSorting.propTypes = {
  sortName: PropTypes.string.isRequired,
  sortOrder: PropTypes.oneOf([SortDirection.ASCENDING, SortDirection.DESCENDING]).isRequired,
  onSortChange: PropTypes.func,
  selectOptions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    selected: PropTypes.bool,
    disabled: PropTypes.bool
  })).isRequired,
  className: PropTypes.string
};
export default TableCardsSorting;